module.exports = __webpack_public_path__ + "static/media/facebook.3b54e1f8.svg";